export default __webpack_public_path__ + "static/WCCC-Logo-09dec3facf70404e92199deebfab4357.svg";